import { Link } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import type { Project } from '@one-deployment/api'
import { Button } from '@/components/ui'
import { RoleGate } from '@/components/RoleGate'
import { dateTime } from '@/lib/format'

/**
 * The repo is gone or the app lost access (03 §5.12). Work keeps going on the
 * box; pushes and PRs queue until a lead reconnects.
 */
export function RepoMissingBanner({ project }: { project: Project }) {
  if (project.repo.state === 'ok') return null
  return (
    <div role="alert" className="flex items-center gap-3 border-b border-warn/30 bg-warn/10 px-5 py-2 text-sm">
      <AlertTriangle size={14} className="shrink-0 text-warn" />
      <span className="flex-1">
        {project.repo.missingReason ?? 'The GitHub repo cannot be reached'}
        {project.repo.missingSince != null && <> since {dateTime(project.repo.missingSince)}</>}. Agents keep working;{' '}
        {project.pendingPrs} PRs queued until it is back.
      </span>
      <RoleGate action="project.repo.reconnect" project={project.key} fallback={<span className="text-xs text-fg-subtle">A lead can reconnect it.</span>}>
        <Link to="/p/$project/settings/$section" params={{ project: project.key, section: 'general' }}><Button variant="primary">Reconnect repo</Button></Link>
      </RoleGate>
    </div>
  )
}
